<template>
  <div>
    <header-component></header-component>
    <main>
      <br>
      ページが見つかりません
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";

export default {
  metaInfo: {
    title: "ページが見つかりません | 訪問支援マッチングサービスアネラ - 訪問支援マッチングサービスアネラは全国でご利用いただける障がい児向け訪問型療育サービスです。お気軽にお問い合わせください。"
  },
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue